import { VOID_CAVE_UPPER_DOOR_RETURN_SPAWN } from "./voidCaveMapConfig";
import { EAST_PASSAGE_MAP_CONFIG } from "./eastPassageMapConfigs";
import { WEST_PASSAGE_MAP_CONFIG } from "./westPassageMapConfigs";

// Doorways to caverns that are not built yet stay sealed (sceneKey: null).
// Register a sceneKey + spawn here once a destination cavern exists and the
// door will start routing to it automatically.
const DEPTHS_EXIT_ROUTES = Object.freeze({
  westExit: Object.freeze({
    sceneKey: "WestPassageScene",
    spawn: WEST_PASSAGE_MAP_CONFIG.entrySpawn,
    doorLabel: "West Passage",
  }),
  eastExit: Object.freeze({
    sceneKey: "EastPassageScene",
    spawn: EAST_PASSAGE_MAP_CONFIG.entrySpawn,
    doorLabel: "East Passage",
  }),
});

export const resolveVoidCaveDepthsEntranceRoute = (entryData = {}) => ({
  sceneKey: "VoidCaveScene",
  spawn: VOID_CAVE_UPPER_DOOR_RETURN_SPAWN,
  cityReturnSpawn: entryData.cityReturnSpawn || entryData.returnSpawn || null,
  doorLabel: "Return To Void Cave",
});

export const resolveVoidCaveDepthsExitRoute = (exitName = "") =>
  DEPTHS_EXIT_ROUTES[exitName] || null;

export const VOID_CAVE_DEPTHS_EXIT_NAMES = Object.freeze(
  Object.keys(DEPTHS_EXIT_ROUTES),
);
